import { useUserAccess } from '../hooks/use-user-access';
import { TrainingManagementPermissions } from '../utils/user.permissions';

const useTrainingManagementEditAccess = () => {
  const { editAccess } = useUserAccess({
    initialAccess: false,
    permissions: {
      MODIFY: [
        TrainingManagementPermissions.TRAINING_MANAGEMENT_MODIFY,
        TrainingManagementPermissions.TRAINING_MANAGEMENT_CREATE,
      ],
    },
  });
  return editAccess;
};

export default useTrainingManagementEditAccess;
